import { render, staticRenderFns } from "./RefferalDetails.vue?vue&type=template&id=c51bcae4"
import script from "./RefferalDetails.vue?vue&type=script&lang=js"
export * from "./RefferalDetails.vue?vue&type=script&lang=js"
import style0 from "./RefferalDetails.vue?vue&type=style&index=0&id=c51bcae4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports